module.exports = __webpack_public_path__ + "img/gb818-85.prt.5fc35e63.jpg";